// Ported from LC2's DaysOnMarketGlance.js (commons/components/HomeTabs/Today/Portfolio/
// Glance/DaysOnMarketGlance.js) — same row-building off each "Historical Days on Market"
// glance row (days_on_market/days_on_market_comps rounded to whole numbers, community lookup
// for us_state), same GlanceDaysOnMarketColumns shape (commons/constants/tableColumns.js:
// property_name, days on market, days on market comps, reduction [percentage, red/green],
// state) and same "no data" empty state (see ./GlanceEmptyState.js).
// SIMPLIFIED: table chrome rebuilt on ../components/DataTableShell.js instead of MUI X
// DataGrid Pro — see ./ConcessionGlance.js's header comment for why.
import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {getCommunities} from '../../../app/store/reducers/entities';
import DataTableShell from '../components/DataTableShell';
import GlanceCell from './GlanceCell';
import GlanceEmptyState from './GlanceEmptyState';
import {getRandomValue} from './utils';

const COLUMN_SPECS = [
    {field: 'property_name', headerName: 'Property name'},
    {field: 'days_on_market', headerName: 'Days On Market'},
    {field: 'days_on_market_comps', headerName: 'Days On Market Comps'},
    {field: 'reduction', headerName: 'Reduction', format: 'percentage', color: 'red/green'},
    {field: 'us_state', headerName: 'State'}
];

const DaysOnMarketGlance = ({data}) => {
    const communities = useSelector(getCommunities);

    const columns = useMemo(
        () =>
            COLUMN_SPECS.map((spec) => ({
                field: spec.field,
                headerName: spec.headerName,
                renderCell: (row) => <GlanceCell value={row[spec.field]} format={spec.format} color={spec.color} colorValue={spec.colorValue} />
            })),
        []
    );

    const rows = useMemo(() => {
        return (data || []).map((d) => {
            const propDom = `${Math.round(d.days_on_market)}`;
            const compsDom = `${Math.round(d.days_on_market_comps)}`;
            const community = communities.find((c) => c.sfid === d.property_sfid);
            let usState = community?.full_address__statecode__s;

            if (!usState && community?.address__c) {
                const parts = community.address__c.split(' ');
                usState = parts[parts.length - 2];
            }

            return {
                ...d,
                id: getRandomValue(),
                days_on_market: propDom,
                days_on_market_comps: compsDom,
                us_state: usState
            };
        });
    }, [data, communities]);

    if (rows.length === 0) {
        return <GlanceEmptyState msg="No days on market data found on public listing sites" type="Glance Metric" />;
    }

    return (
        <DataTableShell
            title="Historical Days on Market"
            description="See how long it took to fill your units that left the market in the last 90 days."
            columns={columns}
            rows={rows}
            getRowId={(row) => row.id}
            searchPlaceholder="Search Days on Market"
        />
    );
};

DaysOnMarketGlance.propTypes = {
    data: PropTypes.array
};

export default DaysOnMarketGlance;
